import React, { FC, useContext } from 'react'
import { ShareIcon, CheckIcon, ChevronLeftIcon } from '@heroicons/react/outline'
import { Link } from 'react-router-dom'
import { userStore } from '../../../utils/UserContext'
import { Button } from '../../../System'
import { useCopyToClipboard } from '../../../utils/copyToClipboard'
import { StyledWorks } from '.'
import ROUTES from '../../../utils/routes'

const Course: FC = () => {
  const { user } = useContext(userStore)
  const {
    isCopied,
    actions: { copyToClipboard }
  } = useCopyToClipboard()
  const { origin } = window.location
  const affiliateUrl = `${origin}/course/signup?affiliate=${user?.id}`

  return (
    <StyledWorks>
      <div className="top-content">
        <Link to={ROUTES.affiliates.links}>
          <Button theme="outline" className="back-btn" isIcon>
            <ChevronLeftIcon />
          </Button>
        </Link>
        <div className="share-link-input-container">
          <span className="share-link-input-label">Share Link</span>
          <div className="share-link-input">
            <span>{affiliateUrl}</span>
            <Button
              iconPos="right"
              className="copy-link-btn"
              isDisabled={isCopied}
              onClick={() => copyToClipboard(affiliateUrl)}
            >
              {isCopied ? (
                <>
                  COPIED <CheckIcon />
                </>
              ) : (
                <>
                  COPY LINK <ShareIcon />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
      <div className="heading">
        <h2>S.O.S Selling on Social Payout Details</h2>
        <p>
          Earn {user?.isWhale ? '50' : '40'}% every time someone uses your link to purchase the
          course.
        </p>
      </div>
      <div className="payout-details">
        <h3>
          <b>You</b> receive a one-time payment of:
        </h3>
        <div className="payout-detail-grid">
          <div className="payout-detail">
            <b>{user?.isWhale ? '50' : '40'}%</b>
            <span>of the current purchase price</span>
          </div>
        </div>
      </div>
    </StyledWorks>
  )
}

export default Course
